// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { type ButtonHTMLAttributes, type ReactElement, type ReactNode, type ComponentType } from 'react';
import { Loader2 } from 'lucide-react';

// Paylaşılan buton — tutarlı varyant + yüklenme spinner'ı + ikon. Birincil = marka gradyanı.
type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  loading?: boolean;
  icon?: ComponentType<{ className?: string }>;
  block?: boolean;
  children: ReactNode;
}

const variantCls: Record<ButtonVariant, string> = {
  primary: 'text-white shadow-lg hover:brightness-105',
  secondary: 'border border-border bg-card text-foreground hover:bg-accent',
  ghost: 'text-foreground hover:bg-accent',
  danger: 'bg-rose-600 text-white hover:bg-rose-700',
};

export function Button({
  variant = 'primary',
  loading = false,
  icon: Icon,
  block = false,
  disabled,
  children,
  className = '',
  style,
  ...rest
}: ButtonProps): ReactElement {
  const isPrimary = variant === 'primary';
  return (
    <button
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-[14px] font-semibold transition-all disabled:opacity-60 disabled:cursor-not-allowed ${variantCls[variant]} ${block ? 'w-full' : ''} ${className}`}
      style={isPrimary ? { background: 'linear-gradient(135deg,#0d9488,#0891b2)', ...style } : style}
      {...rest}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : Icon ? <Icon className="w-4 h-4" /> : null}
      {children}
    </button>
  );
}
